/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetUserMeResponse
} from '../model';

import getUserMeMutator from '../../../mutators/datastore-instance';



  /**
 * sophon を介してログインユーザー情報を取得する
 * @summary ログインユーザー情報取得
 */
export const getUserMe = (

 ) => {
      return getUserMeMutator<GetUserMeResponse>(
      {url: `/users/me`, method: 'GET'
    },
      );
    }
  export type GetUserMeResult = NonNullable<Awaited<ReturnType<typeof getUserMe>>>
